export enum MeasurementMutationTypes {
    SET_MEASUREMENT_REF = "SET_MEASUREMENT_REF",
    ADD_MEASUREMENT_DETAILS = "ADD_MEASUREMENT_DETAILS",
    SET_ACTIVE_MEASUREMENT_TYPE = "SET_ACTIVE_MEASUREMENT_TYPE",
    ADD_TEMPLATE = "ADD_TEMPLATE",
    RESET_MEASUREMENT = "RESET_MEASUREMENT",
}